import custom_api_func from "./axios_api_func"; 
import {getCookie,getCsrfToken} from './get_csrfToken'
const BASE = "api/advisor-chat";

async function getCsrfHeaderValue() {
  await getCsrfToken();
  return getCookie("csrftoken");
}

export const chatApi = {
  getConversation: () => custom_api_func.get(`${BASE}/conversation/${localStorage.getItem('useremail')}`),

  getMessages: (conversationId, sinceId = 0) =>
    custom_api_func.get(`${BASE}/conversation/messages/${conversationId}/${localStorage.getItem('useremail')}`, {
      params: { since: sinceId },
    }),

  sendMessage: async (conversationId, body) => {
    const csrftoken = await getCsrfHeaderValue();
    return custom_api_func.post(
      `${BASE}/conversation/messages/${conversationId}/${localStorage.getItem('useremail')}/`,
      { body },
      {
        headers: {
          "X-CSRFToken": csrftoken,
        },
      }
    );
  },

  markSeen: async (conversationId, lastMessageId) => {
    const csrftoken = await getCsrfHeaderValue();
    return custom_api_func.post(
      `${BASE}/conversation/mark-seen/${conversationId}/${localStorage.getItem('useremail')}/`,
      { last_message_id: lastMessageId },
      {
        headers: {
          "X-CSRFToken": csrftoken,
        },
      }
    );
  },
};

export default custom_api_func;